import axios from "axios";

// Makes axios send cookies
// axios.defaults.withCredentials = true;
axios.defaults.timeout = 900000;

export default axios;
